import { useState } from 'react';

import { observer } from 'mobx-react';

import type { WizardChildProps } from '../../../../components/Wizard/types';

import { LoginForm } from './LoginForm';
import { SignupForm } from './SignupForm';

interface AuthSectionProps {
  onSignupSuccess?: () => void;
  onLoginNeedsVerification?: () => void;
  wizardProps?: WizardChildProps;
  initialMode?: 'signup' | 'login';
}

export const AuthSection = observer(
  ({ onSignupSuccess, onLoginNeedsVerification, wizardProps, initialMode = 'signup' }: AuthSectionProps) => {
    const [isSignupMode, setIsSignupMode] = useState(initialMode === 'signup');

    const switchToLogin = () => setIsSignupMode(false);

    if (isSignupMode) {
      return <SignupForm wizardProps={wizardProps} onSignupSuccess={onSignupSuccess} onSwitchToLogin={switchToLogin} />;
    }

    return <LoginForm wizardProps={wizardProps} onLoginNeedsVerification={onLoginNeedsVerification} />;
  },
);
